export function Roots({ is }) {

   /*   
     switch (is) {
        case "api": return "http://localhost/kompass/api.php";
        case "file": return "http://localhost/kompass/upload";
        default: return "";
    }
   */
    switch (is) {
        case "api": return "https://kompassevent.ch/connect/api.php";
        case "file": return "https://kompassevent.ch/connect/upload";
        case "upload": return "https://kompassevent.ch/connect/upload.php";
        default: return "";
    }

    
}